import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'
import LogoutIcon from '../assets/logout.svg?react'
import { BLUE, HOVER_TINT, SIGN_OUT_YELLOW, lockedFont } from './constants'

interface SignOutRowProps {
    onLogout: () => void
}

const SignOutRow = ({ onLogout }: SignOutRowProps) => {
    const { translate } = useTranslate()

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            onClick={onLogout}
            sx={{
                cursor: 'pointer',
                p: '30px',
                gap: 3,
                bgcolor: BLUE,
                flexShrink: 0,
                '&:hover': { bgcolor: HOVER_TINT }
            }}
            data-testid="sign-out-row-stack-on-logout">
            <Typography
                sx={{
                    ...lockedFont('24px', '36px'),
                    fontFamily: 'var(--font-poppins)',
                    fontWeight: 300,
                    color: SIGN_OUT_YELLOW
                }}
                data-testid="sign-out-row-typography-sign-out">
                {translate('sign_out')}
            </Typography>
            <LogoutIcon style={{ width: 28, height: 24 }} data-testid="sign-out-row-logout-icon" />
        </Stack>
    )
}

export default SignOutRow
